import {ErrorContext} from '@vio/core/src/analytics/types/Events'
import {ErrorResponse} from '@vio/core/src/booking/types/ErrorResponse'

const getErrorContext = (
  error?: ErrorResponse,
  status?: number
): ErrorContext => ({
  errorMessage: error?.message,
  errorType: error?.type as string,
  errorCode: status === undefined ? error?.providerCode : String(status),
  errorDetails: error?.details
})

export default getErrorContext
